export default __webpack_public_path__ + "static/media/arrow_forward_pink.7b147e19.svg";